module.exports = __webpack_public_path__ + "static/media/Lens-Fresh Blue.af68bcc8.png";